import {
    REQUEST_DUPLICATE_LANDING_PAGE,
    DUPLICATE_LANDING_PAGE_SUCCESS,
    DUPLICATE_LANDING_PAGE_ERROR,
} from './actionTypes';

export const requestDuplicateLandingPage = () => ({ type: REQUEST_DUPLICATE_LANDING_PAGE });

export const duplicateLandingPageSuccess = landingPage => ({
    type: DUPLICATE_LANDING_PAGE_SUCCESS,
    payload: landingPage,
});

export const duplicateLandingPageError = payload => ({ type: DUPLICATE_LANDING_PAGE_ERROR, payload });
